// Libs
import React from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

// Components
import {
  Actionbar,
  Flexbox,
  Heading4,
  InformationContainer,
  TableDocumentList,
  ToolButton
} from '@ibinder/common-frontend';

// Utils
import useCheckDocument from 'Shared/Utils/useCheckDocument';
import { templateHeaders } from './transformations.binderTemplates';
import {
  attachTransformedMetadata,
  templatesSettings
} from './transformations.binderTemplates';

// Query
import { GET_ALL_TEMPLATES } from '../../api/queries/queries_local';

// Icons
import { infoCircle } from '@ibinder/common-icons';
import { iBinderHeaderEnum } from '@ibinder/ui-common-models';

const OverviewWrapper = styled.div`
  padding: 0 1rem 1rem 1rem;
  height: 100%;
`;
export const TableContainer = styled.div`
  margin-right: -1rem;
  margin-left: -1rem;
  overflow-y: visible;
  height: 85%;
  align-self: stretch;
`;
const LayoutBinderInformationFlex = styled(Flexbox)`
  @media (max-width: ${(p) => p.theme.devices.sm}px) {
    flex-direction: column;
  }
`;
const NumberOfDocumentsInfo = styled(InformationContainer)`
  margin-left: 0;
  @media (max-width: ${(p) => p.theme.devices.xs}px) {
    margin-left: 0.5rem;
  }
`;
const StyledActionbar = styled(Actionbar)`
  margin-left: -2rem;
  margin-right: -2rem;
  @media (max-width: ${(p) => p.theme.devices.xs}px) {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
`;
const ActionbarContent = styled(Flexbox)`
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  margin: 0.25rem;
`;
const ExtraSpace = styled.span`
  margin-right: 0.75rem;
  @media (max-width: ${(p) => p.theme.devices.xs}px) {
    display: none;
  }
`;

const GlobalBinderTemplates = () => {
  const [selectedIds, setSelectedIds] = useCheckDocument();
  const navigate = useNavigate();

  // Required to pass a x-ibinder-tenantid here
  // Might change later that we don't have to pass anything but for now it works like this
  const globalBinderTemplate = useQuery(GET_ALL_TEMPLATES, {
    context: {
      headers: { [iBinderHeaderEnum.TENANTID]: '' } // Needs to be empty string to override automatic set tenantId
    }
  });

  const templates = globalBinderTemplate?.data?.get;
  const headers = templateHeaders();
  const settings = templatesSettings();

  // Loading if templates is undefined
  const loading = templates === undefined;

  // Transform templates data
  const transformedData = templates
    ? attachTransformedMetadata(templates, settings, headers)
    : [];

  const onViewTemplate = (template) => {
    navigate(`/tab/13/GlobalBinderTemplateList/${template.id}`);
  };

  return (
    <OverviewWrapper>
      <LayoutBinderInformationFlex justifyContent="space-between">
        <NumberOfDocumentsInfo>
          {loading ? (
            <Heading4 loading={loading} label="" />
          ) : (
            <span>
              {`Showing `}
              <strong>{`${templates && templates.length}`}</strong>
              {` templates`}
            </span>
          )}
        </NumberOfDocumentsInfo>
      </LayoutBinderInformationFlex>

      <StyledActionbar>
        <ActionbarContent>
          {selectedIds.length > 0 && (
            <ToolButton
              type="button"
              onClick={() => console.log('open view template')}
            >
              {infoCircle}
              <ExtraSpace>View</ExtraSpace>
            </ToolButton>
          )}
        </ActionbarContent>
      </StyledActionbar>

      <TableContainer>
        {templates && (
          <TableDocumentList
            {...{
              setSelectedIds,
              selectedIds,
              hasSelectBox: true,
              permissionHeaders: []
            }}
            documentQuery={transformedData}
            onSort={null}
            sortBy={null}
            metadataElements={[]}
            headers={headers}
            hasSelectBox={true}
            rowAction={(item) => onViewTemplate(item)}
          />
        )}
      </TableContainer>
    </OverviewWrapper>
  );
};

export default GlobalBinderTemplates;
